import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrlV1 } from "../../../config/config";
import { agent } from "../../../api";
import { FortuneWheelBonus, WheelBonusGlobal, WheelBonusUpdate } from "../../../entities/wheelGame_v2";
import { addNotification } from "../../Notification/notificateStore";
import { handlerNeedUpdate } from "../fortuneWheelTableStore";

const wheelGameUrl = apiUrlV1 + "/v2/organization/game/fortunewheel/prize";

export const getWheelBonus = createAsyncThunk(
  'fotune-wheel/get-bonus-by-id',
  async (param: { id: number }): Promise<FortuneWheelBonus> => {
    try {
      const response = await agent.get(`${wheelGameUrl}/read/${param.id}`)
      if (response.ok) {
        const data = await response.json() as FortuneWheelBonus;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const postWheelBonus = createAsyncThunk(
  'fotune-wheel/post-bonus-by-id',
  async (param: { data: WheelBonusGlobal }, thunksApi): Promise<FortuneWheelBonus> => {
    try {
      const response = await agent.post(`${wheelGameUrl}/create/from-global-settings`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelBonus;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchWheelBonus = createAsyncThunk(
  'fotune-wheel/patch-bonus-by-id',
  async (param: { data: WheelBonusUpdate, id: number }, thunksApi): Promise<FortuneWheelBonus> => {
    try {
      const response = await agent.patch(`${wheelGameUrl}/update/from-config-part/${param.id}`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as FortuneWheelBonus;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'bonus', value: true }));
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)